import type { RouteObject } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'

import { RouterErrorBoundary } from './client/components/Error/RouterErrorBoundary.js'
import { RootRoute } from './RootRoute.js'
import { designRoutes } from './routes/designRoutes.js'
import { embedRoutes } from './routes/embedRoutes.js'
import { createManageRoutes } from './routes/manageRoutes.js'
import { createPublicRoutes } from './routes/publicRoutes.js'
import type { InjectedAppProps } from './server/types/server.types.js'

interface Props {
  injectedAppProps: InjectedAppProps
}

export const createRoutes = ({ injectedAppProps }: Props): RouteObject[] => [
  {
    element: <RootRoute injectedAppProps={injectedAppProps} />,
    errorElement: <RouterErrorBoundary />,
    children: [
      {
        path: `${adminRoutes.people.membersExport(':id')}`,
        async lazy() {
          const { DownloadMembers } = await import(
            './client/components/Admin/Members/DownloadMembers.js'
          )

          return { Component: DownloadMembers }
        },
      },
      {
        async lazy() {
          const { AdminRouteGuard } = await import(
            './client/components/Admin/index.js'
          )

          return { Component: AdminRouteGuard }
        },
        children: [designRoutes, createManageRoutes(injectedAppProps)],
      },
      {
        path: '/auth/logout',
        async lazy() {
          const { Logout } = await import('./client/components/Logout.js')

          return { Component: Logout }
        },
      },
      ...embedRoutes,
      {
        path: '/settings/notifications/unsubscribe',
        async lazy() {
          const { Unsubscribe } = await import(
            './client/components/Settings/Unsubscribe.js'
          )

          return { Component: Unsubscribe }
        },
      },
      createPublicRoutes(injectedAppProps),
    ],
  },
]
